/* 🤖 this file was generated by svg-to-ts */
export const sbIconsExclamationCircleSolid: {
  name: 'exclamation-circle-solid';
  data: string;
} = {
  name: 'exclamation-circle-solid',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20"><path fill="currentColor" d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0m0 15c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1m1-5c0 .6-.4 1-1 1s-1-.4-1-1V6c0-.6.4-1 1-1s1 .4 1 1z"/></svg>`
};
